

import moment from 'moment';

import { useSelector } from 'react-redux';

import { DateType, IDashboardReportState } from '@store/slices';
import { ILoginState } from '@share/store/slices';

import { DashboardReportHeaderItem, HeaderItemColor, HeaderItemType } from './dashboard-report-header-item';

import { faArrowTrendUp, faBan, faCalculator, faSackDollar } from '@fortawesome/free-solid-svg-icons';

import Overview from '@assets/images/overview.svg';

import './style.scss';
import { FormattedMessage } from 'react-intl';

export function DashboardReportHeader() {  
  const dashboardReportsStore = useSelector((state: { dashboardReportsStore: IDashboardReportState }) => state.dashboardReportsStore);
  const loginStore = useSelector((state: { loginStore: ILoginState }) => state.loginStore);
  
  const { loading, dashBoardData, request } = dashboardReportsStore;
  const { fromDate, toDate, dateType } = request;

  const from = fromDate ? moment(fromDate, 'MM/DD/yyyy') : null;
  const to = toDate ? moment(toDate, 'MM/DD/yyyy') : null;
  const diff = dateType === DateType.LAST_30 ? 30 : 
               dateType === DateType.LAST_7 ? 7 : 
               dateType === DateType.LAST_60 ? 60 : 
               dateType === DateType.LAST_90 ? 90 : 
               (dateType === DateType.CUSTOM_RANGE && from && to) ? 
                  to?.diff(from, 'days') : 0;

  return (
    <div className="dashboard-report-header-wrapper">
      <div className="dashboard-report-header-wrapper__message">
        <div className="dashboard-report-header-wrapper__welcome">
          <img src={Overview} className="welcome-image" alt="overview_image" />
          <div className="welcome-message">
            <label><FormattedMessage id="my.account.capital.welcome" values={{userName : loginStore?.user?.firstName}} />!</label>
            <span><FormattedMessage id="nav.companysettings.overview.message" values={{confirmedBookings : dashBoardData?.confirmedBookings, diff : diff}} /></span>
          </div>
        </div>
      </div>
      <div className="dashboard-report-header-wrapper__data">
        <DashboardReportHeaderItem type={HeaderItemType.NUMBER} loading={loading} title={'Company Reservations'} icon={faArrowTrendUp} value={dashBoardData?.confirmedBookings} color={HeaderItemColor.BLUE} />
        <DashboardReportHeaderItem type={HeaderItemType.CURRENCY} loading={loading} title={'Budget Spend'} icon={faCalculator} value={dashBoardData?.sales} color={HeaderItemColor.GREEN} />
        <DashboardReportHeaderItem type={HeaderItemType.CURRENCY} loading={loading} title={'savings'} icon={faSackDollar} value={dashBoardData?.savings} color={HeaderItemColor.GREEN} />
        <DashboardReportHeaderItem type={HeaderItemType.NUMBER} loading={loading} title={'cancellations'} icon={faBan} value={dashBoardData?.canceledBookings} color={HeaderItemColor.RED} />
      </div>
    </div >
  );
}
